module.exports = __webpack_public_path__ + "img/ico-badge-star.c2873329.svg";